import { WabunkaExperienceEventReservationType } from '@japan-culture-and-technology/wabunka-protos/ts_proto/wabunka_experience_event_reservation_type';

import { formatHyphenatedDate } from '@/utils/date';
import type { WabunkaExperienceEventDictViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

import type dayjs from 'dayjs';

export type AvailabilityStatus = 'FULL' | 'UNAVAILABLE' | 'CONFIRMED_INSTANTLY' | 'ON_REQUEST';
/**
 * 予約可能状態とラベル、画像パス、説明文をマッピング
 */
export const availabilityStatusMap: Record<AvailabilityStatus, { imagePath?: string; label: string; description?: string }> = {
  FULL: {
    imagePath: '/img/calendar/full.svg',
    label: 'Full',
  },
  UNAVAILABLE: {
    imagePath: '/img/calendar/no_events.svg',
    label: 'Unavailable',
  },
  CONFIRMED_INSTANTLY: {
    label: 'Instant Booking',
    description: 'Your reservation is confirmed immediately upon payment.',
  },
  ON_REQUEST: {
    label: 'Request Booking',
    description: 'You will receive confirmation after the host reviews your request.',
  },
};

export const getAvailabilityStatusBasedOnDate = (day: dayjs.Dayjs, calendarEvents: WabunkaExperienceEventDictViewModel): AvailabilityStatus => {
  const hyphenatedDate = formatHyphenatedDate(day);
  const events = calendarEvents[hyphenatedDate];
  if (events == null) {
    return 'UNAVAILABLE';
  }

  // 予約可能なイベントがない場合
  const reservableEvents = events.filter((event) => event.canReserve);
  if (reservableEvents.length === 0) {
    return 'FULL';
  }

  // INSTANTが1つでもある場合は四角背景
  const hasInstant = reservableEvents.some((event) => (event.effectiveReservationType ?? event.reservationType) === WabunkaExperienceEventReservationType.EXPERIENCE_EVENT_RESERVATION_TYPE_INSTANT);
  if (hasInstant) {
    return 'CONFIRMED_INSTANTLY';
  }

  return 'ON_REQUEST';
};
